import React from "react";
import { NETIV_LOGO_DATA_URI } from "./logo";

export interface LogoProps {
  /** Rendered height in px. Width follows the source aspect ratio. */
  height?: number;
  className?: string;
}

/** The approved NETIV gold/navy brand mark. Use in app headers. */
export function Logo({ height = 24, className }: LogoProps) {
  return (
    <img
      src={NETIV_LOGO_DATA_URI}
      alt="NETIV"
      className={className}
      style={{ height, width: "auto", display: "block", borderRadius: 3 }}
    />
  );
}
